import styled, { css } from 'styled-components';
import { colors, dimensions, typography } from '../common/styles';
import { lighten } from '../common/styles/color';
import { twinkling } from 'modules/common/utils/animations';

const basename = process.env.PUBLIC_URL || "";

const UserHelper = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;
const Layout = styled.main`
  height: 100%;
  display: flex;
  flex: 1;
  max-width: 100%;
  background: #ebebff;
`;

const MainWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-top: 70px;
  padding-left: ${dimensions.headerSpacingWide}px;
  max-width: 100%;
  @media (max-width: 768px) {
    padding-left: 0;
  }
`;

const SectionBody = styled.div`
  i {
    color: ${colors.colorCoreLightGray};
    &:hover {
      cursor: pointer;
    }
  }
`;

const Contents = styled.div`
  display: flex;
  flex: 1;
  margin: ${dimensions.coreSpacing}px;
  margin-right: 10px;
  height: 93%;
  max-height: 93%;

  display: flex;
  flex: 1 1 0%;
  max-height: 100%;
  position: absolute;
  inset: 0px;
  overflow-x: auto;
  padding-left: 70px;
  padding-top: 70px;

  @-moz-document url-prefix() {
    overflow: hidden;
  }

  @media (max-width: 768px) {
    overflow-x: hidden;
    // z-index: 10 !important;
    padding-left: 26px;
  }
`;

const MainContent = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 475px;
  border-radius: 20px;
  box-shadow: ${props =>
    !props.transparent && `0 0 8px 1px ${colors.shadowPrimary}`};
  margin-right: ${dimensions.coreSpacing}px;
  // background: ${colors.colorCoreRed};
  background-color: ${props => !props.transparent && colors.colorWhite};

  @media (max-width: 768px) {
    /* overflow: ${props => props.overflow || "auto"}; */
    min-width: -webkit-fill-available;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
   
    
  }
`;

const ContentSpace = styled.div`
  padding: ${dimensions.coreSpacing}px;
`;

const ContentBox = styled.div`
  flex: 1;
  // overflow: auto;
  overflow: ${props => !props.overflow && 'inherit'};
  position: relative;
  background-color: ${props => !props.transparent && colors.colorWhite};
  // background: #fff;
  // border-bottom-left-radius: 20px;
  // border-bottom-right-radius: 20px;
  border-radius: 20px;
  // padding: 15px;
`;

const ContentHeader = styled.div`
  // background: ${props =>
    props.background === 'transparent' ? 'none' : colors[props.background]};
  background: #eef3fa;
  min-height: ${dimensions.headerSpacing}px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom: 1px solid ${colors.borderPrimary};
  display: flex;
  justify-content: space-between;
  padding: 12px;
  margin: 20px;
  border-radius: 9px;

  label {
    color: ${colors.themeBlack};
    margin: 0px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.5px;
  }
`;

const ContentHeaderData = styled.div`
  // background: ${props =>
    props.background === 'transparent' ? 'none' : colors[props.background]};
  background: #fff;
  min-height: ${dimensions.headerSpacing}px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom: 1px solid ${colors.borderPrimary};
  display: flex;
  justify-content: space-between;
  padding: 12px;
  // margin: 20px;
  border-radius: 9px;

  label {
    color: ${colors.themeBlack};
    margin: 0px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.5px;
  }
`;

const ContenFooter = styled.div`
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  // padding: 15px;
  ${ContentHeader} {
    border-bottom: none;
    border-top: 1px solid ${colors.borderPrimary};
  }
`;

const BarItems = styled.div`
  > * + * {
    margin-left: ${dimensions.unitSpacing}px;
  }

  input[type='text'] {
    width: auto;
    display: inline-block;
  }
  @media (max-width: 768px) {
  float: right;
    // > * {
    // margin-right: -20px;
    // margin-bottom: 3px;
    // }
  }
`;

const HeaderItems = styled.div`
  align-self: center;
  margin-left: ${props => props.rightAligned && 'auto'};
`;

const SideContent = styled.section`
  box-sizing: border-box;
  display: flex;
  position: relative;
  flex-direction: column;
  flex-shrink: 0;
  height: 100%;
  border-radius: 10px;
  width: ${props => (props.wide ? '360px' : '300px')};
  flex: ${props => (props.half ? '1' : 'none')};
  margin-right: ${dimensions.coreSpacing}px;
  background: ${props => (props.full ? colors.colorWhite : 'none')};
  box-shadow: ${props =>
    props.full ? `0 0 8px 1px ${colors.shadowPrimary}` : 'none'};
`;

const SidebarHeader = styled.div`
  background-color: ${colors.bgLight};
  height: ${dimensions.headerSpacing}px;
  border-radius: 20px 20px 0px 0px;
  // margin: 5px;
  margin-bottom: ${props => props.spaceBottom && '10px'};
  align-items: center;
  padding: 0 ${dimensions.coreSpacing}px 0 ${dimensions.coreSpacing}px;
  border-bottom: 1px solid ${colors.borderPrimary};
  text-transform: ${props => props.uppercase && 'uppercase'};
  // font-weight: ${props => (props.bold ? 'bold' : 'normal')};
  font-weight: 500;
  display: flex;
  font-size: ${typography.fontSizeHeading8}px;
  flex-direction: row;
  justify-content: space-between;
  color: ${colors.colorPrimary}
`;

const SidebarTitle = SidebarHeader.withComponent('h3').extend`
  padding: 0 ${dimensions.coreSpacing}px;
  margin: 0 0 -1px 0;
  text-transform: uppercase;
`;

const SidebarMainContent = styled.div`
  overflow: hidden auto;
  flex: 1;
  position: relative;
`;

const SidebarFooter = SidebarHeader.extend`
  border-top: 1px solid ${colors.borderPrimary};
  border-bottom: none;
`;

const SidebarBox = styled.div`
  border-radius: 5px;
  background-color: ${props => (props.noBackground ? '' : colors.colorWhite)};
  margin-bottom: ${dimensions.coreSpacing}px;
  box-shadow: ${props =>
    props.noShadow ? 'none' : `0 0 8px 1px ${colors.shadowPrimary}`};
  padding-bottom: ${props =>
    props.collapsible ? `${dimensions.unitSpacing}px` : '0'};
  position: ${props => (props.full ? 'initial' : 'relative')};
  justify-content: center;
  transition: max-height 0.4s;
  overflow: ${props => (props.collapsible ? 'hidden' : 'initial')};
  display: ${props => props.full && 'flex'};

  &:last-child {
    margin-bottom: 0;
  }
`;

const BoxContent = styled.div`
  flex: 1;

  ul {
    padding: 5px 0;
  }
`;

const SidebarToggle = styled.a`
  width: 100%;
  color: ${colors.colorCoreGray};
  position: absolute;
  bottom: 0;
  text-align: center;
  padding: 2px 0;
  font-size: 10px;
  background: ${colors.bgLight};
  border-top: 1px solid ${colors.borderPrimary};

  &:hover {
    cursor: pointer;
  }

  &:focus {
    outline: 0;
  }
`;

const HelperButtons = styled.div`
  position: absolute;
  right: ${dimensions.coreSpacing}px;
  top: 15px;
  color: ${colors.colorCoreLightGray};

  a {
    float: left;
    color: ${colors.colorCoreLightGray};
    text-transform: none;
    cursor: pointer;
    margin-left: ${dimensions.unitSpacing}px;
    font-size: ${typography.fontSizeHeading8}px;
    font-weight: ${typography.fontWeightLight};
    outline: 0;

    > i {
      font-size: 14px;
      margin-right: 0;

      &:hover {
        color: ${colors.colorCoreBlack};
      }
    }
  }
`;

const FieldStyle = styled.div`
  white-space: nowrap;
  overflow: ${props => (props.overflow ? props.overflow : 'hidden')};
  text-overflow: ellipsis;
  flex: 1;
`;

const SidebarList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;

  li.child-segment {
    border-bottom: none;
    background-color: ${colors.bgLight};

    > span {
      background-color: ${colors.bgLight};
      box-shadow: -2px 0 10px 2px ${colors.bgLight};
    }
  }

  &.no-link li,
  a {
    display: block;
    padding: 6px 20px;
    color: ${colors.textPrimary};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: none;
    outline: 0;
    position: relative;
    border-left: 2px solid transparent;
    transition: background 0.3s ease;

    > i {
      margin-right: 5px;
    }

    &:hover,
    &.active {
      cursor: pointer;
      background: ${colors.bgActive};
      text-decoration: none;
      outline: 0;
      color: ${lighten(colors.textPrimary, 40)};
    }

    &.active {
      border-left: 2px solid ${colors.colorPrimary};
    }
  }

  div {
    &.active {
      cursor: pointer;
      background: ${colors.bgActive};
      text-decoration: none;
      outline: 0;
      color: ${lighten(colors.textPrimary, 40)};
    }

    &.active {
      border-left: 2px solid ${colors.colorPrimary};
    }
  }

  .icon {
    margin-right: 6px;
    color: ${colors.colorCoreGray};
  }
`;

const SidebarCounter = styled.span`
  font-size: ${typography.fontSizeHeading}px;
  text-align: ${props => (props.nowrap ? 'left' : 'right')};
  color: ${colors.colorCoreGray};
  margin-top: 2px;
  position: ${props => !props.nowrap && 'absolute'};
  right: ${dimensions.coreSpacing}px;
  max-width: ${props => (props.nowrap ? '100%' : '60%')};
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: ${props => (props.nowrap ? '0' : '10px')};

  a {
    padding: 0;
    color: ${colors.linkPrimary};
  }

  span {
    float: right;
    margin-left: 5px;
  }

  ${props =>
    props.nowrap &&
    css`
      display: block;
      white-space: normal;
    `};
`;

const FlexContent = styled.div`
  display: flex;
  flex: 1;
  min-height: 100%;
`;

const FlexItem = styled.div`
  flex: ${props => (props.count ? props.count : 1)};
  position: relative;
`;

const FlexRightItem = styled.div`
  margin-left: auto;
`;

const WhiteBoxRoot = styled.div`
  margin-bottom: ${dimensions.coreSpacing}px;
  background-color: ${colors.colorWhite};
  box-shadow: 0 0 8px 1px ${colors.shadowPrimary};
`;

const WhiteBox = WhiteBoxRoot.extend`
  flex: 1;
  overflow: auto;
  position: relative;
`;

const Authlayout = styled.div`
  background-color: white;
  height: 100vh;
  overflow: auto;
  position: relative;
  background:url('/images/backgroundImage.png');
background-color: white;
  // background: #212557; 
  flex: 1;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;

  @media (max-width: 768px) {
    background: url('/images/backgroundImage.png');
background-color: white;
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: cover;

  }

  &:before {
    content: '';
    position: relative;
    width: 100%;
    height: 100%;
    // background: transparent url('/images/twinkling.png') repeat top center;
    // animation: ${twinkling} 200s linear infinite;
  }
`;

const AuthContent = styled.div`
  /* position: absolute; */
  // top: 50%;
  // transform: translateY(-50%);
  height: 100%;
  /* padding: 2rem; */

  .bgRow {
    height: 65%;
    display: flex;
    /* margin-top: -30px; */
    // align-items: center;

    @media (max-width: 768px) {
      padding-left: 0px;
      padding-right: 0px;
padding-top: 20px;
    }
  }

  .row {
margin-left: 2px;
    width: 100%;
    /* margin: auto; */
    display: flex;
/* flex-direction: column; */
    align-items: center;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;

const AuthDescription = styled.div`
  @media (max-width: 768px) {
    text-align: center;
    justify-content: center;
  }
  
  img {
    width: 40rem;
    margin-bottom: 20px;
    @media (max-width: 768px) {
      width: 20rem;
      margin-bottom: 20px;
      text-align: center;
      justify-content: center;
    }
  }
  h1 {
    font-weight: bold;
    font-size: 26px;
    margin-bottom: 20px;
    /* color: #212121; */
    margin-top: 10px;
  }
  /* p {
    color: #626262;
    margin-bottom: 50px;
    font-size: 16px;
    // width: 80%;
    // text-align: justify;
    // line-height: 1.8em;
    letter-spacing: 1px;
  } */
  /* a {
    color: rgba(255, 255, 255, 0.7);
  } */
  .not-found {
    margin-top: 0;
  }
`;


const Links = styled.div`
  color: #303030;
  margin-bottom: 0px;
  font-size: 16px;
  text-align: justify;
  font-weight: 600;
  margin-bottom: 100px;
  a {
    color: #364aae;
    font-weight: 600;
  }
`;

const ContentsItems = styled.div`
  display: flex;
  flex: 1 1 0%;
  max-height: 100%;
  /* position: absolute; */
  inset: 0px;
  // overflow-x: auto;
  overflow: ${props => !props.overflow && 'inherit'};
  padding-left: 15px;
  padding-top: 10px;
  margin-right: -4px;
  height: auto;
  max-height: 100%;
  @media (max-width:760px) {
    /* margin-right: -13px; */
    overflow-x: hidden;
    margin-right: -2px;
    padding-left: 19px;
    /* margin-left: -20px; */
   
    /* /* padding-left: 10px; */
    /* margin-right: -18px; */

  }
`;


const BalanceDetails = styled.div`
/* border: 1px solid ${colors.colorCoreGray}; */
border-radius: 15px;
/* padding: 2px 4px; */
/* margin-left: 8px; */
// margin-right: 14px;
// display: flex;
// flex-direction: column;
display: flex;
/* grid-template-columns: repeat(2, 1fr); */
align-items: baseline;
// gap: 10px;
text-align: center;
// align-items: center;
font-weight: 600;
span:nth-child(1) {
  font-size: 14px;
  
  
}
span:nth-child(2) {
 
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  /* line-height: 18px;
  margin: 2px; */

  >a {
    /* color: #36454F; */
  }
}
@media(max-width: 768px) {
/* border: 1px solid ${colors.colorCoreGray};
border-radius: 9px;
padding: 2px 8px;
margin-left: 8px;
text-align: center;
font-weight: 600;
span:nth-child(1) {
  font-size: 10px;
}
span:nth-child(2) {
  font-size: 18px;
} */


  display: none;
}
`;

export {
  Layout,
  MainWrapper,
  Contents,
  MainContent,
  ContentBox,
  ContenFooter,
  ContentHeader,
  ContentSpace,
  HeaderItems,
  BarItems,
  SideContent,
  SidebarHeader,
  SidebarMainContent,
  SidebarFooter,
  BoxContent,
  SidebarToggle,
  SidebarCounter,
  HelperButtons,
  SidebarTitle,
  UserHelper,
  SidebarList,
  FieldStyle,
  SidebarBox,
  FlexContent,
  FlexItem,
  SectionBody,
  FlexRightItem,
  WhiteBoxRoot,
  WhiteBox,
  Authlayout,
  AuthContent,
  AuthDescription,
  Links,
  ContentsItems,
  ContentHeaderData,
  BalanceDetails
};



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/layout/styles.js